module.exports = __webpack_public_path__ + "img/video-cover.22347905.png";